import React from 'react'
import Behaviors from './Behaviors'
import Transform from './Transform'
import { useGatheredToolbars } from "../../toolbar/Tools"

const Data = () => {
  const toolbars = useGatheredToolbars({ name: 'dataToolbar' })

  return (
    <div className='content'>
      {toolbars || <p className='instructional'>Select a field label to get started.</p>}
    </div>
  )
}

export default Data
